import EventEmitter from 'events';

const eventEmitter1 = new EventEmitter();

export default eventEmitter1;
